import gql from "graphql-tag";

/**
 * eventMakersV2 — recurring events for ONE company, filtered + projected on the
 * server.
 *
 * Replaces the v1 `eventMakers` query on the Event Maker page, which did
 * `EventMaker.find({}).sort('date')` with full-document instructor/users
 * populates and no projection — i.e. every maker in the database — and then
 * filtered by company in the browser. Measured on the largest company:
 * 9,982 ms / 4,018 KB -> 404 ms / 10 KB.
 *
 * Field selection matches the v1 query exactly, so the page renders identically.
 */
const eventMakersV2Query = gql`
  query eventMakersV2($companyId: String!) {
    eventMakersV2(companyId: $companyId) {
      _id
      title
      style
      instructor {
        firstName
        lastName
        _id
      }
      enablePush
      users {
        _id
        firstName
        lastName
        email
      }
      location
      date
      dateEnd
      totalSpots
      description
      image
      coins
      cron
      isLive
      zoomUrl
      avgRating
      site
      hoursTillEvent
      company {
        _id
      }
    }
  }
`;

export default eventMakersV2Query;
